var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import merge from 'lodash/merge';
import { StyleSheet } from 'react-native';
import { TRANSPARENT, buttonConfig, tokens } from '../../constants';
import { checkIsPlatform, getCurrentEventControlState } from '../../utils';
export var getButtonIconSize = props => {
  var buttonType = props.buttonType,
    size = props.size;
  var sizes = {
    sm: 14,
    md: 18,
    lg: 20
  };
  var isPrimaryAndSecondary = buttonType === 'primary' || buttonType === 'secondary';
  return isPrimaryAndSecondary ? sizes.sm : sizes === null || sizes === void 0 ? void 0 : sizes[size];
};
export var getButtonIconColor = (pressableState, props) => {
  var _a, _b, _c;
  var controlState = getCurrentEventControlState(pressableState, props === null || props === void 0 ? void 0 : props.controlState);
  var buttonType = (_a = props === null || props === void 0 ? void 0 : props.config) === null || _a === void 0 ? void 0 : _a[props === null || props === void 0 ? void 0 : props.buttonType];
  var color = (_c = (_b = buttonType === null || buttonType === void 0 ? void 0 : buttonType.controlState) === null || _b === void 0 ? void 0 : _b[controlState]) === null || _c === void 0 ? void 0 : _c.textColor;
  return color;
};
export var getButtonLoaderProps = props => {
  var _a, _b, _c, _d;
  var isDisabled = (props === null || props === void 0 ? void 0 : props.disabled) || (props === null || props === void 0 ? void 0 : props.controlState) === 'disabled';
  var controlState = (_b = (_a = props === null || props === void 0 ? void 0 : props.config) === null || _a === void 0 ? void 0 : _a[props === null || props === void 0 ? void 0 : props.buttonType]) === null || _b === void 0 ? void 0 : _b.controlState;
  var loaderColor = (_c = controlState === null || controlState === void 0 ? void 0 : controlState.none) === null || _c === void 0 ? void 0 : _c.textColor;
  var spacingTokens = tokens.spacing;
  var loaderSize = {
    sm: 12,
    md: 14,
    lg: 18
  };
  var style = {
    marginLeft: spacingTokens.SPACING_4
  };
  if ((props === null || props === void 0 ? void 0 : props.loaderPosition) === 'left') style = {
    marginRight: spacingTokens.SPACING_4
  };
  if (isDisabled) loaderColor = (_d = controlState === null || controlState === void 0 ? void 0 : controlState.disabled) === null || _d === void 0 ? void 0 : _d.textColor;
  return {
    noPadding: true,
    style,
    customSize: loaderSize[props === null || props === void 0 ? void 0 : props.size],
    color: loaderColor
  };
};
export var getButtonTitleTypes = size => {
  var buttonTypes = {
    sm: "body-single-line-sm-bold",
    md: "body-single-line-md-bold",
    lg: "body-single-line-lg-bold"
  };
  return buttonTypes === null || buttonTypes === void 0 ? void 0 : buttonTypes[size];
};
export var getButtonStyles = (pressableState, props, isThrottled) => {
  var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
  var _props$isSelected = props.isSelected,
    isSelected = _props$isSelected === void 0 ? false : _props$isSelected,
    _props$disabled = props.disabled,
    disabled = _props$disabled === void 0 ? false : _props$disabled,
    _props$buttonType = props.buttonType,
    type = _props$buttonType === void 0 ? 'primary' : _props$buttonType,
    _props$isCapitalize = props.isCapitalize,
    isCapitalize = _props$isCapitalize === void 0 ? true : _props$isCapitalize,
    _props$isUpperCase = props.isUpperCase,
    isUpperCase = _props$isUpperCase === void 0 ? false : _props$isUpperCase,
    noHoverEffect = props.noHoverEffect,
    noPressEffect = props.noPressEffect;
  var noHoverPressEffect = noHoverEffect || noPressEffect;
  var controlState = !noHoverPressEffect ? getCurrentEventControlState(pressableState, props === null || props === void 0 ? void 0 : props.controlState) : 'none';
  var isPrimaryOrSecondary = type === 'primary' || type === 'secondary';
  if (isSelected && isPrimaryOrSecondary) controlState = 'selected';
  if (disabled || isThrottled) controlState = 'disabled';
  var buttonType = (_a = props === null || props === void 0 ? void 0 : props.config) === null || _a === void 0 ? void 0 : _a[props === null || props === void 0 ? void 0 : props.buttonType];
  var buttonTypeControlState = (_b = buttonType === null || buttonType === void 0 ? void 0 : buttonType.controlState) === null || _b === void 0 ? void 0 : _b[controlState];
  var buttonSize = (_c = buttonType === null || buttonType === void 0 ? void 0 : buttonType.size) === null || _c === void 0 ? void 0 : _c[props === null || props === void 0 ? void 0 : props.size];
  var spacingTokens = tokens.spacing;
  var buttonSizeStyles = {
    height: buttonSize === null || buttonSize === void 0 ? void 0 : buttonSize.height,
    paddingHorizontal: spacingTokens === null || spacingTokens === void 0 ? void 0 : spacingTokens[buttonSize === null || buttonSize === void 0 ? void 0 : buttonSize.paddingHorizontal]
  };
  var versionTypesStyles = (_d = buttonType === null || buttonType === void 0 ? void 0 : buttonType.version) === null || _d === void 0 ? void 0 : _d[props === null || props === void 0 ? void 0 : props.version];
  var iconFlexDirection = (_f = (_e = buttonType === null || buttonType === void 0 ? void 0 : buttonType.iconPosition) === null || _e === void 0 ? void 0 : _e[props === null || props === void 0 ? void 0 : props.iconPosition]) === null || _f === void 0 ? void 0 : _f.flexDirection;
  var loaderFlexDirection = (props === null || props === void 0 ? void 0 : props.loaderPosition) == 'left' ? 'row-reverse' : 'row';
  var _buttonTypeControlSta = buttonTypeControlState.borderWidth,
    borderWidth = _buttonTypeControlSta === void 0 ? 1 : _buttonTypeControlSta,
    buttonColor = buttonTypeControlState.buttonColor,
    borderRadius = buttonTypeControlState.borderRadius,
    _buttonTypeControlSta2 = buttonTypeControlState.borderColor,
    borderColor = _buttonTypeControlSta2 === void 0 ? TRANSPARENT : _buttonTypeControlSta2,
    restButtonTypeControlState = __rest(buttonTypeControlState, ["borderWidth", "buttonColor", "borderRadius", "borderColor"]);
  var buttonBorderRadius = borderRadius && ((_g = tokens.borderRadius) === null || _g === void 0 ? void 0 : _g[borderRadius]);
  var iconStyle = (_h = buttonType === null || buttonType === void 0 ? void 0 : buttonType.iconPosition) === null || _h === void 0 ? void 0 : _h[props === null || props === void 0 ? void 0 : props.iconPosition];
  var marginLeft = iconStyle.marginLeft,
    marginRight = iconStyle.marginRight;
  var iconMarginLeft = spacingTokens === null || spacingTokens === void 0 ? void 0 : spacingTokens[marginLeft];
  var iconMarginRight = spacingTokens === null || spacingTokens === void 0 ? void 0 : spacingTokens[marginRight];
  var buttonTextColor = (_k = (_j = buttonType === null || buttonType === void 0 ? void 0 : buttonType.controlState) === null || _j === void 0 ? void 0 : _j[controlState]) === null || _k === void 0 ? void 0 : _k.textColor;
  return StyleSheet.create({
    container: Object.assign(Object.assign(Object.assign(Object.assign({
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      flexGrow: 0,
      backgroundColor: buttonColor
    }, buttonSizeStyles), versionTypesStyles), restButtonTypeControlState), {
      borderRadius: buttonBorderRadius,
      borderColor: borderColor,
      borderWidth,
      maxWidth: '100%'
    }),
    buttonLoaderContainer: {
      flexDirection: loaderFlexDirection,
      maxWidth: '100%'
    },
    buttonIconContainer: {
      flexDirection: iconFlexDirection,
      alignSelf: 'center',
      alignItems: 'center',
      justifyContent: 'center',
      maxWidth: '100%'
    },
    buttonIcon: Object.assign(Object.assign(Object.assign({}, iconStyle), iconMarginLeft && {
      marginLeft: iconMarginLeft
    }), iconMarginRight && {
      marginRight: iconMarginRight
    }),
    buttonText: Object.assign(Object.assign(Object.assign({
      color: buttonTextColor
    }, isCapitalize && {
      textTransform: 'capitalize'
    }), isUpperCase && {
      textTransform: 'uppercase'
    }), checkIsPlatform('web') && {
      userSelect: 'none'
    })
  });
};
export var getButtonProps = (props, context) => {
  var _a;
  var theme = (props === null || props === void 0 ? void 0 : props.theme) || context.theme;
  var configProps = merge(buttonConfig === null || buttonConfig === void 0 ? void 0 : buttonConfig[theme], (_a = context === null || context === void 0 ? void 0 : context.button) === null || _a === void 0 ? void 0 : _a[theme]);
  var controlState = (props === null || props === void 0 ? void 0 : props.disabled) && 'disabled' || (props === null || props === void 0 ? void 0 : props.controlState) || (configProps === null || configProps === void 0 ? void 0 : configProps.controlState);
  return Object.assign(Object.assign(Object.assign({
    theme
  }, configProps), props), {
    controlState
  });
};